import React from 'react';
import { useTranslation } from "react-i18next";


export default function Acerca()
{
    const { t } = useTranslation();
    return(
        <section className="page-section bg-primary text-white mb-0" id="websites">
            <div className="container">
            <div className="row">
            <h2 className="page-section-heading text-center text-uppercase text-white" style={{margin:'20px'}}>{t('nav_menu2')}</h2>
                    <h3 className="text-center">{t('web_title1')}</h3>
                    <p className="text-center">{t('web_text1')}</p>
                    <ul className="listText">
                        <li className="text-center">{t('web_ul1_li1')}</li>
                        <li className="text-center">{t('web_ul1_li2')}</li>
                        <li className="text-center">{t('web_ul1_li3')}</li>
                        <li className="text-center">{t('web_ul1_li4')}</li>
                        <li className="text-center">{t('web_ul1_li5')}</li>
                        <li className="text-center">{t('web_ul1_li6')}</li>
                        <li className="text-center">{t('web_ul1_li7')}</li>
                    </ul>
                    <h3 className="text-center">{t('web_title2')}</h3>
                    <p className="text-center">{t('web_text2')}</p>
                    <p className="text-center">{t('web_text3')}</p>
                    <p className="text-center">{t('web_text4')}</p>
                    <ul className="listText">
                        <li className="text-center">{t('web_ul2_li1')}</li>
                        <li className="text-center">{t('web_ul2_li2')}</li>
                        <li className="text-center">{t('web_ul2_li3')}</li>
                        <li className="text-center">{t('web_ul2_li4')}</li>
                        <li className="text-center">{t('web_ul2_li5')}</li>
                    </ul>
                    <h3 className="text-center">{t('web_title3')}</h3>
                    <p className="text-center">{t('web_text5')}</p>
                    <p className="text-center">{t('web_text6')}</p>
                    <p className="text-center">{t('web_text7')}</p>
                    <ul className="listText">
                        <li className="text-center">{t('web_ul3_li1')}</li>
                        <li className="text-center">{t('web_ul3_li2')}</li>
                        <li className="text-center">{t('web_ul3_li3')}</li>
                        <li className="text-center">{t('web_ul3_li4')}</li>
                    </ul>
                </div>
            </div>
        </section>
    )
}